import { reactive } from 'vue'
import { getBooleanFromValue } from '@/global/utils/utils'

export function useInfoDialog () {
  const state = reactive({
    isOpen: false,
    title: '',
    message: '',
    showLoader: false,
    onConfirm: null
  })

  /**
   * Opens a modal dialog with the specified title, message, and confirmation callback.
   *
   * @param {Object} options - The options for configuring the modal dialog.
   * @param {string} options.title - The title of the modal dialog.
   * @param {string} options.message - The message displayed in the modal dialog.
   * @param {boolean} [options.showLoader=false] - Whether to show a loading indicator in the modal dialog.
   * @param {Function} [options.onConfirm] - An optional callback function executed when the confirmation action is triggered.
   */
  const open = ({ title, message, showLoader = false, onConfirm }) => {
    state.isOpen = true
    state.title = title
    state.message = message
    state.showLoader = showLoader
    state.onConfirm = onConfirm || null
  }

  /**
   * Closes the modal dialog and resets its state.
   */
  const close = () => {
    state.isOpen = false
    state.title = ''
    state.message = ''
    state.showLoader = false
    state.onConfirm = null
  }

  const setLoader = (val) => {
    state.showLoader = getBooleanFromValue(val)
  }

  return {
    state,
    open,
    close,
    setLoader
  }
}
